import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MatSidenavModule } from "@angular/material/sidenav";
import { TranslateModule } from "@ngx-translate/core";
import { MainHeaderNavbarMobileSideComponentGeneric } from "./navbar-mobile-side";
import { VarietyOptionModuleGeneric } from '@signature-it/ngx-generic/components/variety-options';
import { LangsSidebarModuleGeneric} from '@signature-it/ngx-generic/components/languages';
import { UserLoginNavbarModuleGeneric, UserLoginModuleGeneric} from '@signature-it/ngx-generic/components/user-login';
import {SearchSidebarModuleGeneric} from '@signature-it/ngx-generic/components/search-form';
import {SafePipeModule} from '@signature-it/ngx-generic/pipes';

@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        TranslateModule,
        MatSidenavModule,
        UserLoginModuleGeneric,
        UserLoginNavbarModuleGeneric,
        LangsSidebarModuleGeneric,
        VarietyOptionModuleGeneric,
        SearchSidebarModuleGeneric,
        SafePipeModule
    ],
    declarations: [MainHeaderNavbarMobileSideComponentGeneric],
    exports: [MainHeaderNavbarMobileSideComponentGeneric]
})
export class MainHeaderNavbarMobileSideModuleGeneric {}
